"use client"

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectLanguage, selectUser } from "@/app/redux/store"

import ProjectCard from "../project-card/project-card"
import Label from "../label/Label"
import { getAllCurrentsProjectsByType, getAllUsersByPartner, getLabels, getPartner } from "@/app/adapters/api"
import { GridSkeleton } from "../../skeleton/gridSkeleton"
import { isNonNullExpression } from "typescript"

const labelsNames = [
  "preference-option-one", 
  "preference-option-two", 
  "preference-option-three", 
]

export default function CurrentInvestmentsCarousel(props: {projectType: string}) {
  const userState = useSelector(selectUser)

  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState<any>({})
  const lang = useSelector(selectLanguage)

  const [currentProjects, setCurrentProjects] = useState<any>([])
  const [availableCurrentProjects, setAvailableCurrentProjects ] = useState(0)
  const [projectTypeSelected, setProjectTypeSelected] = useState(props.projectType)
  const [skip, setSkip] = useState(0)
  const [limit, setLimit] = useState(3)

  useEffect(() => {
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels)
      })
      .finally(() => {
        setLoading(false)
      });
  }, [])

  useEffect(() => {
    loadProjects(projectTypeSelected)
  }, [projectTypeSelected])

  const loadProjects = async (projectType: string) => {
  setLoading(true);
  try {
    const response = await getAllCurrentsProjectsByType(projectType, skip, limit);
    const projectsIn = response.data.projects;
    const updatedProjects = await Promise.all(projectsIn.map(async (project: any) => {
      if (project?.exclusive === true && project?.status === 'precampaign' && userState.isLogin) {
        const partnerIds = project.projectPartners.map((partnerObj: any) => partnerObj.partner);
        const userId = String(userState.id);
        const showResults = await Promise.all(partnerIds.map(async (partnerId: any) => {
          try {
            const partnerResponse = await getPartner(partnerId);
            const userResponses = await getAllUsersByPartner(partnerId, partnerResponse.data.partner.access);
            const partnerUsersIds = userResponses.data.partnerUsers.map((user: any) => String(user.partnerUser.id));
            const usersWithPartnerCodeIds = userResponses.data.usersWithPartnerCode.map((user: any) => String(user.id));
            const allUserPartners = [...partnerUsersIds, ...usersWithPartnerCodeIds];
            return allUserPartners.includes(userId);
          } catch (err) {
            console.error("Error in partner/user fetch", err);
            return false;
          }
        }));
        project.show = showResults.includes(true);
      } else {
        project.show = !project?.exclusive;
      }
      return project;
    }));

    const filteredProjects = updatedProjects.filter((project: any) => project.show);
    setCurrentProjects(filteredProjects);
    setAvailableCurrentProjects(response.data.totalProjects);
    const newSkip = skip + limit;
    setSkip(newSkip);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

 /*  const loadProjects = (projectType: string) => {
    setLoading(true)
    getAllCurrentsProjectsByType(projectType, skip, limit)
      .then((response) => {
        setAvailableCurrentProjects(response.data.totalProjects)
        setCurrentProjects(response.data.projects)
        const newSkip = skip + limit;
        setSkip(newSkip)
      })
      .finally(() => {
        setLoading(false)
      });
  } */



  const handleSelectProjectType = (projectType: string) => {
    setSkip(0);
    setProjectTypeSelected(projectType)
  }

  const handleAddProjects = () => {
    getAllCurrentsProjectsByType(projectTypeSelected, skip, limit)
      .then((response) => {
        const newProjects = [...currentProjects, ...response.data.projects]
        setCurrentProjects(newProjects)
        setAvailableCurrentProjects(response.data.totalProjects)
        const newSkip = skip + limit;
        setSkip(newSkip)
      })
      .finally(() => {
        setLoading(false)
      });
  }

  return (
    <section className="my-4">
      {/* <div className="flex justify-center items-center divide-x-2 divide-lbs-secondary-orange">
          <p onClick={() => handleSelectProjectType('all')} 
            className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "all" 
                        ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
              <Label label={labels.preferenceOptionOne	} lang={lang}/>
          </p>
          <p onClick={() => handleSelectProjectType('equity')} 
              className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "equity" 
                        ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
              <Label label={labels.preferenceOptionTwo	} lang={lang}/>
          </p>
          <p onClick={() => handleSelectProjectType('lending')} 
            className={"w-[180px] text-sm	sm:text-2xl px-4 py-2 text-center font-bold cursor-pointer " + (projectTypeSelected === "lending" 
                        ? "text-lbs-secondary-orange" : "hover:text-lbs-secondary-orange")}>
              <Label label={labels.preferenceOptionThree	} lang={lang}/>
          </p>
      </div> */}
      {
        loading ?
        <GridSkeleton />
        :
        <>
          <div className="flex justify-center flex-wrap gap-4 md:gap-8 mt-8 md:p-4">
            {currentProjects.map((project: any) => {
              return <ProjectCard key={project.id} projectId={project.id} lang={lang}/>
            })}
          </div>
          {/* {
            availableCurrentProjects > skip ?
            <div className="flex justify-center mt-4 mb-8">
              <button 
                className="w-[44px] h-[44px] text-2xl rounded-full bg-lbs-secondary-orange text-white cursor-pointer"
                onClick={handleAddProjects}>+</button>
            </div>
            :
            null
          } */}
        </>
      }
    </section>
  )
}
